import { all, put, take, spawn } from 'redux-saga/effects';

import { PIPELINE__INITIALIZE_EREADER } from 'PipeRouter';

import createPageViewer from './createPageViewer';
import getAnnotations from './getAnnotations';
import setIframeAttributes from './setIframeAttributes';
import normalizeAll from './normalizeAll';
import saveAnnotations from './saveAnnotations';
import getPageBreaks from './getPageBreaks';
import getTOC from './getTOC';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPELINE__INITIALIZE_EREADER);
    yield put({ type: cmd, data });
  }
}


export default function* initializeEreader() {
  yield all([
    spawn(getTOC),
    pipeline(),
    createPageViewer(),
    getAnnotations(),
    getPageBreaks(),
    normalizeAll(),
    saveAnnotations(),
    setIframeAttributes()
  ]);
}
